module.exports = __webpack_public_path__ + "img/active.4ce5de4f.svg";